import { render } from "./BagFailure.vue?vue&type=template&id=91221310&scoped=true"
import script from "./BagFailure.vue?vue&type=script&lang=js"
export * from "./BagFailure.vue?vue&type=script&lang=js"

import "./BagFailure.vue?vue&type=style&index=0&id=91221310&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91221310"]])

export default __exports__